import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_SEARCH_ADDRESS_TYPES } from 'constants/urls';

interface AddressTypeFilters {
  SearchKeyword?: string;
  Page?: number;
  Take?: number;
}

const searchAddressTypes = async (filters: AddressTypeFilters = {}) => {
  const payload = {
    Id: 0,
    SearchKeyword: filters.SearchKeyword || '',
    Page: filters.Page || 1,
    Take: filters.Take || 2147483647,
  };

  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_SEARCH_ADDRESS_TYPES}?payload=${JSON.stringify(payload)}`,
      { headers: { 'Content-Type': 'application/json;charset=UTF-8' }, data: null },
    );
    return data;
  } catch (error) {
    console.error('[searchAddressTypes] Failed:', error);
    throw error;
  }
};

export default searchAddressTypes;
